var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.615159 5.93156C1.00568 5.54104 1.63885 5.54104 2.02937 5.93156L5.32227 9.22446L5.32227 1.63867C5.32227 1.08639 5.76998 0.638672 6.32227 0.638672C6.87455 0.638672 7.32227 1.08639 7.32227 1.63867L7.32227 9.22446L10.6152 5.93157C11.0057 5.54104 11.6388 5.54104 12.0294 5.93157C12.4199 6.32209 12.4199 6.95525 12.0294 7.34578L7.12624 12.3458C6.92512 12.5469 6.63395 12.6444 6.34549 12.6384C6.33777 12.6386 6.33003 12.6387 6.32227 12.6387C6.04573 12.6387 5.79541 12.5264 5.61438 12.345L0.615159 7.34578C0.224635 6.95525 0.224635 6.32209 0.615159 5.93156Z",
    fill: "#EF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down-Arrow.433572744723a80755e9b20a06bdea16.svg";
export { ForwardRef as ReactComponent };